import './index.scss'

jQuery(document).ready(function ($) {
    let productlistingblocks = $('.pagebuilder__block--product-listing');
    if (productlistingblocks.length === 0) {
        return;
    }

    productlistingblocks.each( (index, block) => {
        let $block = $(block);
        let $grid = $block.find('.products--listing');
        let $productConditionFilter = $block.find('.product--condition__filter');
        let $productTypeFilter = $block.find('.product--type__filter');
        
        if ($productConditionFilter.length > 0) {
            setDisabledOptions($productConditionFilter);
            $productConditionFilter.on('change', (event) => {
                $grid.isotope({ filter: event.target.value });
            });
        }

        if ($productTypeFilter.length > 0) {
            setDisabledOptions($productTypeFilter);
            $productTypeFilter.on('change', (event) => {
                $grid.isotope({ filter: event.target.value });
            });
        }

        //Set disabled options for filters
        function setDisabledOptions($filter) {
            $filter.find('option').each(function () {
                let optionValue = $(this).val();
                if (!$grid.find(optionValue).length) {
                    $(this).prop('disabled', true);
                } else {
                    $(this).prop('disabled', false);
                }
            });
        }
    });
});
